import { Auth } from "../../api/Channel/Auth";
import { ROLE, UAA_CHILDREN_PATH } from "modules/Channel/configs/constant";
import {
  KEY_CHANNEL_CURRENT_USER,
  KEY_LIST_ROLE_BIZZ_UAA,
  KEY_ROLE_BIZZ_UAA,
} from "modules/UAA/configs/constant";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { setCurrentMenuApp } from "redux/bizzAppReducer";
import store from "store";
import authApi from "../../api/config";
import uaaApi from "../../api/uaaConfig";
import { errorMsg } from "../../helper/message";
import { LOCAL_STORAGE, setDataSession } from "../../helper/session";
import { removeCmsToken, setCmsToken, setUserSession } from "../../helper/user";
import { setCurrentBizzApp } from "../../redux/bizzAppReducer";

export const loginAxios = (data) => {
  return authApi({
    method: "post",
    url: "/oauth/login",
    data,
    headers: { "Content-Type": "application/json" },
  });
};

export const logoutAxios = () => {
  return authApi({
    method: "get",
    url: "/oauth/logout",
    headers: { "Content-Type": "application/json" },
  });
};

export const getUserData = () => {
  return uaaApi({
    method: "get",
    url: "/api/v1/user/current-user",
  });
};

export const ALLOW_ACCESS_DASHBOARD = [
  ROLE.HO_STAFF,
  ROLE.HO_BO,
  ROLE.HO_REVIEWER,
  ROLE.MD_EXTERNAL_BO,
  ROLE.MD_EXTERNAL_REVIEWER,
  ROLE.MD_EXTERNAL_STAFF,
  ROLE.SA_EXTERNAL_BO,
  ROLE.SA_EXTERNAL_STAFF,
  ROLE.SA_EXTERNAL_REVIEWER,
  ROLE.AGENT_KEY_EXTERNAL,
];

export const useLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const getAccountInfo = async () => {
    const userDetail = await getUserData();
    setUserSession(userDetail?.data?.data);
  };
  const languageKey = "languageCode";
  const languageKeyValue = localStorage.getItem(languageKey);

  const loginAccount = async (dataLogin) => {
    try {
      setLoading(true);
      const requestBody = {
        username: dataLogin?.username,
        password: dataLogin?.password,
        grant_type: "password",
      };
      const loginDetail = await loginAxios(requestBody);
      const { data } = loginDetail;
      setCmsToken(data?.data);
      await getAccountInfo();

      // Get current role for Agent
      const {
        data: { data: currentRoleData },
      } = await Auth.currentRoleUser();

      if (!!currentRoleData) {
        setDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA, {
          code: currentRoleData.activeRole.code,
        });

        setDataSession(
          LOCAL_STORAGE,
          KEY_CHANNEL_CURRENT_USER,
          currentRoleData.channel
        );

        setDataSession(
          LOCAL_STORAGE,
          KEY_LIST_ROLE_BIZZ_UAA,
          currentRoleData.userRoles
        );
      }

      // const { data: dataConfig } = await CommonAPI.getConfig(
      //   TYPE_CONFIG.WITHDRAW_REVIEW
      // );

      // if (dataConfig && !dataConfig.errorCodes) {
      //   setDataSession(LOCAL_STORAGE, CONFIG_REVIEW, dataConfig.data.value);
      // }
      /**
       * ==== UNUSED ====
       * Used to bypass OTP
       * @function setDataSession
       * @function navigate
       * =================
       *
       * Use @function dispatch(setIsLogin(true)) to save login's status
       * When login, step 1 is going to verify user/password
       * If success will save status to store.
       */

      const isAdmin = currentRoleData?.userRoles.find(
        (item) => item.code === ROLE.ADMIN
      );

      /**
       * == UNCOMMENT WHEN USING OTP ====
       */
      // if (!!isAdmin) {
      //   setDataSession(LOCAL_STORAGE, "isLogin", true);
      //   navigate("/");
      // } else {
      //   dispatch(setIsConfirmUser(true));
      // }

      // ====================

      /**
       * == COMMENT WHEN USING OTP ====
       */
      const isRedirectDashboard = ALLOW_ACCESS_DASHBOARD.includes(
        currentRoleData?.activeRole?.code
      );

      isRedirectDashboard && currentRoleData?.activeRole?.code !== ROLE.ADMIN
        ? navigate(UAA_CHILDREN_PATH.ULTILITIES_DASHBOARD)
        : navigate("/");
      setDataSession(LOCAL_STORAGE, "isLogin", true);

      // ====================
      setLoading(false);
    } catch (err) {
      errorMsg(err, "Error");
      dispatch(setCurrentBizzApp(null));
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem(languageKey, languageKeyValue);

      setLoading(false);
    }
  };

  const logoutAccount = async () => {
    await logoutAxios();
    setDataSession(LOCAL_STORAGE, "isLogin", false);
    dispatch(setCurrentMenuApp([]));
    dispatch(setCurrentBizzApp(null));
    removeCmsToken();
    store.clearAll();
    localStorage.clear();
    localStorage.setItem(languageKey, languageKeyValue);
    navigate("/login");
  };
  return { loginAccount, logoutAccount, loading, getAccountInfo };
};
